<!-- @format -->

<template>
	<!-- Una sola fila de controles con la etiqueta arriba, como el gestor de
	     certplag: todos con la misma altura y alineados al borde de la tabla. -->
	<div class="gestor-controles">
		<div class="fila-controles">
			<div class="control-filtro control-filtro--ancho">
				<div class="control-filtro__label">Buscar</div>
				<v-text-field
					:value="filtro.search"
					dense
					filled
					hide-details
					clearable
					height="35px"
					append-icon="mdi-magnify"
					placeholder="Ej: 3072, Decco, luis"
					class="control-filtro__campo control-filtro__campo--ancho"
					@input="valor => emitir({ search: valor || '' })"
					@click:clear="emitir({ search: '' })"
				/>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Tipo de servicio</div>
				<v-select
					:value="filtro.tipos"
					:items="tiposDisponibles"
					item-text="texto"
					item-value="valor"
					multiple
					dense
					filled
					hide-details
					height="35px"
					placeholder="Todos"
					class="control-filtro__campo"
					@change="valor => emitir({ tipos: valor })"
				>
					<template v-slot:item="{ item, attrs, on }">
						<v-list-item v-bind="attrs" v-on="on">
							<v-list-item-action class="mr-2">
								<v-checkbox :input-value="filtro.tipos.includes(item.valor)" />
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title class="d-flex align-center">
									<span
										class="punto mr-2"
										:style="`background-color:${item.color}`"
									/>
									{{ item.texto }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-slot:selection="{ item, index }">
						<span v-if="index === 0" class="caption text-truncate">{{
							item.texto
						}}</span>
						<span v-else-if="index === 1" class="caption text--secondary ml-1"
							>+{{ filtro.tipos.length - 1 }}</span
						>
					</template>
				</v-select>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Técnico</div>
				<v-select
					:value="filtro.persona"
					:items="opcionesTecnicos"
					item-text="texto"
					item-value="valor"
					dense
					filled
					hide-details
					clearable
					height="35px"
					placeholder="Todos"
					class="control-filtro__campo"
					@change="valor => emitir({ persona: valor || '' })"
				/>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Ordenar por</div>
				<v-select
					:value="filtro.orden"
					:items="opcionesOrden"
					item-text="texto"
					item-value="valor"
					dense
					filled
					hide-details
					height="35px"
					class="control-filtro__campo"
					@change="valor => emitir({ orden: valor })"
				/>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Desde</div>
				<v-text-field
					:value="filtro.desde"
					type="date"
					dense
					filled
					hide-details
					height="35px"
					class="control-filtro__campo control-filtro__campo--fecha"
					@change="valor => emitir({ desde: valor || '' })"
				/>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Hasta</div>
				<v-text-field
					:value="filtro.hasta"
					type="date"
					dense
					filled
					hide-details
					height="35px"
					class="control-filtro__campo control-filtro__campo--fecha"
					@change="valor => emitir({ hasta: valor || '' })"
				/>
			</div>

			<div class="control-filtro">
				<div class="control-filtro__label">Vista</div>
				<v-btn-toggle
					:value="vista"
					mandatory
					dense
					color="info"
					class="filter-toggle control-filtro__campo"
					@change="valor => $emit('vista', valor)"
				>
					<v-btn value="auto" small height="35">
						<v-icon small color="info">mdi-auto-fix</v-icon>
					</v-btn>
					<v-btn value="tabla" small height="35">
						<v-icon small color="info">mdi-table</v-icon>
					</v-btn>
					<v-btn value="tarjetas" small height="35">
						<v-icon small color="info">mdi-view-agenda-outline</v-icon>
					</v-btn>
				</v-btn-toggle>
			</div>
		</div>

		<div class="fila-resumen">
			<v-chip
				v-if="filtrosActivos"
				x-small
				color="info"
				outlined
				close
				close-icon="mdi-close"
				@click:close="$emit('limpiar')"
			>
				{{ filtrosActivos }} filtro{{ filtrosActivos > 1 ? 's' : '' }} activo{{
					filtrosActivos > 1 ? 's' : ''
				}}
			</v-chip>
			<v-spacer />
			<span class="fila-resumen__texto">{{ resumen }}</span>
		</div>
	</div>
</template>

<script>
import { TIPOS_BASE } from '@/utils/workOrders/tipos';

export default {
	name: 'WorkOrderFilters',
	props: {
		filtro: { type: Object, required: true },
		tecnicos: { type: Array, default: () => [] },
		vista: { type: String, default: 'auto' },
		resumen: { type: String, default: '' },
	},
	data() {
		return {
			tiposDisponibles: TIPOS_BASE,
			opcionesOrden: [
				{ valor: 'fecha', texto: 'Fecha de actividad' },
				{ valor: 'folio', texto: 'Folio' },
				{ valor: 'certificado', texto: 'Fecha de certificado' },
				{ valor: 'ot', texto: 'Fecha de la OT' },
			],
		};
	},
	computed: {
		opcionesTecnicos() {
			return this.tecnicos.map(tecnico => ({
				valor: tecnico._id,
				texto: `${tecnico.firstName} ${tecnico.lastName || ''}`.trim(),
			}));
		},
		filtrosActivos() {
			return [
				this.filtro.search,
				this.filtro.tipos && this.filtro.tipos.length,
				this.filtro.persona,
				this.filtro.desde,
				this.filtro.hasta,
				this.filtro.estado !== 'todas' ? this.filtro.estado : '',
			].filter(Boolean).length;
		},
	},
	methods: {
		emitir(cambios) {
			this.$emit('cambiar', cambios);
		},
	},
};
</script>

<style lang="scss" scoped>
/* Misma caja de 1500px centrada que la tabla: los controles arrancan en el
   borde izquierdo de la tabla, no antes. */
.gestor-controles {
	max-width: 1500px;
	margin: 0 auto;
	// 1px de borde + 12px de padding de la caja de meses
	padding: 0 13px;
}

.fila-controles {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-end;
	gap: 12px;
	max-width: 1500px;
}

.control-filtro {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}

.control-filtro__label {
	font-size: 13px;
	font-weight: 500;
	color: #37474f;
	line-height: 1.2;
	margin-bottom: 4px;
	text-align: left;
}

.control-filtro__campo {
	min-width: 170px;
}

.control-filtro__campo--ancho {
	min-width: 260px;
}

.control-filtro__campo--fecha {
	min-width: 140px;
	max-width: 150px;
}

.filter-toggle {
	background-color: transparent !important;
	box-shadow: none;
}

.fila-resumen {
	display: flex;
	align-items: center;
	min-height: 26px;
	margin-top: 6px;
}

.fila-resumen__texto {
	font-size: 12px;
	color: #607d8b;
}

.punto {
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
}

/* En el teléfono los filtros ocupan el ancho completo, uno debajo del otro */
@media (max-width: 599px) {
	.gestor-controles {
		padding: 0 8px;
	}

	.fila-controles {
		gap: 10px;
	}

	.control-filtro {
		flex: 1 1 100%;
		min-width: 0;
	}

	.control-filtro__campo,
	.control-filtro .v-input {
		min-width: 0;
		width: 100%;
		max-width: none !important;
	}
}
</style>
